import {css, keyframes} from '@emotion/react';
import React from 'react';

import useColor from '../styles/useColor';

const LoadingIndicator = () => {
  const {palette} = useColor();

  const rotation = keyframes({
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  });

  const loadingIndicatorCss = css({
    height: 48,
    width: 48,
    border: `3px solid ${palette.background.neutral.defaultColor}`,
    borderRadius: '100%',
    position: 'relative',
    animation: `${rotation} 1s linear infinite`,

    '&::after': {
      content: '""',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: 40,
      height: 40,
      borderRadius: '100%',
      border: `3px solid`,
      borderColor: ` ${palette.background.accent.defaultColor} transparent`,
    },
  });

  return (
    <div css={{overflow: 'hidden'}}>
      <div css={loadingIndicatorCss} />
    </div>
  );
};

export default LoadingIndicator;
